import { render, staticRenderFns } from "./tipsign.vue?vue&type=template&id=1cbd24b2&scoped=true&"
import script from "./tipsign.vue?vue&type=script&lang=js&"
export * from "./tipsign.vue?vue&type=script&lang=js&"
import style0 from "./tipsign.vue?vue&type=style&index=0&id=1cbd24b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd24b2",
  null
  
)

export default component.exports